<template>
  <div class="row m-0">
    <div class="col-12 col-md-3 p-3 d-flex">
      <form class="align-self-center flex-fill">
        <div class="form-group" data-bs-toggle="tooltip" data-bs-delay="500" title="Compare overall performance among population">
          <label>Compared to population of</label>
          <select class="form-control" v-model="chartPopulation" :disabled="isLoading">
            <option value="all">All Examinees</option>
            <option value="organization">{{ organizationDisplayName }}</option>
          </select>
          <small class="form-text text-muted">Sample size: {{ sampleSize }}</small>
        </div>
      </form>
    </div>
    <div v-if="showChart" class="col-12 col-md-9 p-3">
      <LineChart v-if="chartData" :data="chartData" :options="chartOptions" style="height: 200px;" />
    </div>
    <div v-if="!showChart" class="col-12 col-md-8 p-3 d-flex justify-content-center align-items-center" style="height: 232px;">
      <div v-if="!isEnoughPopulation()">
        <p class="text-center text-muted">
          Population size not large enough for statistical significance.
        </p>
      </div>
      <div v-else>
        <p class="text-center text-muted">
          No data available
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/charts/LineChart.vue";

export default {
  components: {
    LineChart,
  },
  props: {
    isLoading: Boolean,
    organizationId: String,
    reportId: String,
    report: Object,
  },
  data() {
    return {
      chartPopulation: "all",
      chartSampleSize: null,
      chartData: null,
      chartOptions: null,
      showChart: false,
    };
  },
  computed: {
    organizationDisplayName() {
      return this.report ? this.report.organizationDisplayName : "My Organization";
    },
    sampleSize() {
      try {
        return this.chartSampleSize.toLocaleString();
      } catch {
        return this.chartSampleSize;
      }
    },
  },
  watch: {
    chartPopulation() {
      this.loadChart();
    },
    report() {
      this.loadChart();
    },
  },
  mounted() {
    this.loadChart();
  },
  methods: {
    isEnoughPopulation() {
      if (!this.chartSampleSize || this.chartSampleSize < 30) {
        return false;
      }
      return true;
    },
    loadChart() {
      this.showChart = false;
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/reports/${this.reportId}/charts/risk-index?populationCode=${this.chartPopulation}`)
        .then(res => {
          const chartOptions = {
            legend: false,
            title: {
              display: true,
              text: ["The chart above illustrates the interviewee's performance compared to the population chosen in the drop down list."],
              position: "bottom",
            },
            maintainAspectRatio: false,
            elements: {
              point: {
                radius: 0,
              },
            },
            tooltips: {
              enabled: false,
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    display: false,
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    maxTicksLimit: 10,
                  },
                },
              ],
            },
            plugins: {
              datalabels: false,
            },
            annotation: {
              annotations: [
                {
                  type: "line",
                  scaleID: "x-axis-0",
                  mode: "vertical",
                  borderColor: "#cb4c55",
                  value: String(res.data.score),
                  label: {
                    content: `${res.data.score}%`,
                    backgroundColor: "#cb4c55",
                    fontColor: "white",
                    position: "top",
                    enabled: true,
                  },
                },
              ],
            },
          };

          const chartData = {
            labels: [],
            datasets: [
              {
                type: "line",
                label: "Average Score (Population)",
                data: [],
                backgroundColor: [],
              },
            ],
          };

          res.data.dataPoints.forEach(point => {
            chartData.labels.push(point.label);
            chartData.datasets[0].data.push({ x: point.x, y: point.y });
            chartData.datasets[0].backgroundColor.push("#e9ecef");
            this.showChart = true;
          });

          this.chartSampleSize = res.data.sampleSize;
          this.chartData = chartData;
          this.chartOptions = chartOptions;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

@media print {
  .form-control {
    -webkit-appearance: none;
    border: none;
    font-weight: bold;
    padding-left: 0;
  }
}
</style>
